module.exports = __webpack_public_path__ + "img/third-place.cceece8d.png";